<template>
  <div class="ml-3 trackers-con pt-3">
    <h5 class="mt-3">
      TRACKER COMBINATION: {{ convertStringToTitle(trackerCombination) }}
    </h5>
    <p
      class="mb-5 tag bg-blue text-white small"
    >
      THIS COMBINATION IS PLACEMENT LEVEL
    </p>

    <edit-panel
      :item="item"
      :tracker-combination="trackerCombination"
    />

    <base-wizard-footer
      :next-text="'Done'"
      :next-icon="false"
      @next-step="onDone"
    />
  </div>
</template>

<script>

import EditPanel from './EditPanel.vue';
import textHelper from '@/core/mixins/textHelper';
import BaseWizardFooter from '@/components/BaseWizardFooter.vue';

export default {
  name: 'EditPlacementTrackersModal',
  components: {
    BaseWizardFooter,
    EditPanel,
  },
  props: {
    trackerCombination: {
      type: String,
      required: true,
      default: 'ALL',
    },
    item: {
      type: Object,
      required: true,
    },
  },
  mixins: [textHelper],
  methods: {
    onDone() {
      this.$root.$emit('bv::hide::modal', 'editPlacementTrackersModal');
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
